import React, { useContext } from 'react'
import Globalcontext from '../../Context/Globalcontext';
import Endexam from "../../imgs/endexam.png";
import './Dialog.css'

const Dialog = ({ message, onDialog, submessage,functionname,button1text,button2text }) => {

    const a = useContext(Globalcontext);
    const handlecancel= ()=>{
        if(a.minutes >= 0 && a.seconds >1)
        {
            onDialog(false);
        }
    }

    const handledialog = ()=>{
        onDialog(true);
        functionname();
    }
    return (
        <div
            style={{
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                backgroundColor: "rgba(0,0,0,0.5)"
            }}
           
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    background: "white",
                    padding: "20px",
                    borderRadius: "10px",
                    backgroundColor: "whitesmoke"
                }}
            >
                <div className="dialogmain">
                    <div className="icondialog">
                        <img src={Endexam} alt="" />
                    </div>
                    <span style={{ color: "#111", fontSize: "15px", fontWeight: "bold" }}>{message}</span>
                    <span style={{ marginTop: "4px", color: "black", fontSize: "16px" }}>{submessage}</span>
                   
                        <div className="buttonclass">
                            <button
                                onClick={handledialog}
                                className="buttonend"
                            >
                                {button1text}
                            </button>
                            <button
                                onClick={handlecancel}
                                style={{
                                    color: "#111",
                                    cursor: "pointer",
                                    marginTop: "1px",
                                    background: "none"
                                }}
                            >
                                {button2text}
                            </button>
                        </div>
                 
                </div>
            </div>
        </div>
    )
}

export default Dialog
